import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const emissionFactorService = createApi({
    reducerPath: 'emissionFactorService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    endpoints: (builder) => ({
        saveEmissionFactor: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateEmissionFactor: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.update}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteEmissionFactor: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.delete}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getEmissionFactorById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        searchEmissionFactors: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllEmissionFactors: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadEmissionFactor: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionFactorController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    }),
});

export const {
    useSaveEmissionFactorMutation,
    useUpdateEmissionFactorMutation,
    useDeleteEmissionFactorMutation,
    useGetEmissionFactorByIdMutation,
    useSearchEmissionFactorsMutation,
    useFindAllEmissionFactorsMutation,
    useBulkUploadEmissionFactorMutation,
} = emissionFactorService;
